import { useCallback, useEffect, useMemo, useState } from "react";
import { fetchAllCategories } from "../../service/category/categoryService";

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadCategories = async () => {
      try {
        const data = await fetchAllCategories();
        if (isMounted) setCategories(data);
      } catch (error) {
        setError("Không thể tải danh mục.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadCategories();

    return () => {
      isMounted = false;
    };
  }, []);

  //DÙNG USEMEMO ĐỂ CHỈ TÍNH TOÁN KHI CATEGORY THANH ĐỔI
  const categoryMap = useMemo(() => {
    const map = new Map();

    //hàm đệ quy để duyệt qua từng cây
    const flattenTree = (nodes) => {
      if (!nodes || !nodes.length) return;
      for (const node of nodes) {
        map.set(node.CategoryID, node);
        // Tiếp tục đi sâu vào các con của nó
        flattenTree(node.Children || []);
      }
    };
    flattenTree(categories); // Bắt đầu từ gốc
    return map;
  }, [categories]);

  //MỘT SỐ HÀM TIỆN ÍCH CÂN DÙNG
  const findCategoryById = useCallback(
    (id) => {
      return categoryMap.get(id);
    },
    [categoryMap]
  );

  const findParentOf = useCallback(
    (childId) => {
      const child = categoryMap.get(childId);
      if (!child || !child.ParentID) {
        return null; // Không có con hoặc là category gốc
      }
      return categoryMap.get(child.ParentID);
    },
    [categoryMap]
  );

  return {
    categories,
    loading,
    error,
    categoryMap,
    findCategoryById,
    findParentOf,
  };
};
